var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPool = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 0.75
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.375 6.875h16.25M4.354 14.687s3.188-1.062 5.313 0 3.541-1.062 5.666 0 5.313 0 5.313 0M4.354 16.93s3.188-1.062 5.313 0 3.541-1.062 5.666 0 5.313 0 5.313 0M4.354 19.056s3.188-1.063 5.313 0 3.541-1.063 5.666 0 5.313 0 5.313 0M4.354 6.896V20M20.646 6.896V20"
})), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M8.604 9.02h5.667M8.604 11.146h5.667M8.604 13.27h5.667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.604 4.417v9.916M11.083 4.417v1.77M16.75 4.417v1.77M14.27 4.417v9.916M16.75 4.417c0-.783-.457-1.417-1.24-1.417s-1.24.634-1.24 1.417M11.083 4.417c0-.783-.457-1.417-1.24-1.417s-1.239.634-1.239 1.417"
}))));
export default SvgPool;